export default __webpack_public_path__ + "5aef6544adb270241539dad6b30b192d.svg";